import type { Audience } from "@/features/quote/shared/quote-config";

// Shown on the wizard's first step when the customer arrived from the
// "Har du en opgave mere?" CTA on a thank-you page. That link prefills the
// audience and postal code, and the postal code isn't visible until several
// steps later - so without this the fields just appear filled in with no
// explanation.
//
// The guidance names where each field actually is: the audience is the choice
// on this very step, the postal code comes further forward. Deliberately not
// "click back" - this is step one, so there is nothing behind it.
export function PrefillNotice({
  audience,
  postalCode,
}: {
  audience: Audience | null;
  postalCode: string;
}) {
  const audienceLabel =
    audience === "privat" ? "privat bolig" : audience === "erhverv" ? "erhverv" : null;
  const filled = [audienceLabel, postalCode ? `postnummer ${postalCode}` : null].filter(
    (v): v is string => v !== null,
  );

  if (filled.length === 0) return null;

  const howToChange = [
    audienceLabel ? "vælge om herunder" : null,
    postalCode ? "rette postnummeret når du kommer til det" : null,
  ]
    .filter((v): v is string => v !== null)
    .join(" og ");

  return (
    <div className="mb-7 rounded border border-border bg-paper px-4 py-3 text-[13px] leading-relaxed text-ink-muted">
      <strong className="font-medium text-ink">Vi har udfyldt {filled.join(" og ")}</strong> ud fra
      din forrige opgave. Er den nye opgave anderledes, kan du {howToChange}.
    </div>
  );
}
